var exports = {
  "yF": "AutocompleteMention.module__divider___dFFFM2",
  "xB": "AutocompleteMention.module__personaNameWrapper___dFFFM2",
  "_M": "AutocompleteMention.module__personaName___dFFFM2",
};

module.exports = exports;
